var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
// TODO: Move these functions to broadcastStore and refactor other calls to go through the store
export function fetchAllBroadcasts() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/notifications/broadcast");
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function createBroadcast(broadcast) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().POST("/api/notifications/broadcast", {
            body: broadcast,
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function updateBroadcast(id, broadcast) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/notifications/broadcast/{notification_id}", {
            params: {
                path: { notification_id: id },
            },
            body: broadcast,
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
